'use strict';

var foreach = require('../utils/foreach'),
    TraversingStack = require('../utils/traversing-stack');

/**
 * Checks if the element is 'mountable'
 *
 * @param {HTMLElement} el
 * @returns {boolean}
 */
function isMountable(el) {
    return el.hasAttribute('data-component') || el.hasAttribute('data-name');
}

/**
 * Search mountable elements in the DOM subtree of @param $root
 *
 * @param {jQuery} $root
 * @returns {Array} The list of the mountable elements retreived
 */
function componentsFinder($root) {
    var childs = [];

    foreach($root, function (el) {
        var traversingStack = new TraversingStack(),
            current;

        traversingStack.push(el.children);

        while (!traversingStack.empty()) {
            current = traversingStack.pop();

            if (isMountable(current)) {
                childs.push(current);
            } else {
                traversingStack.push(current.children);
            }
        }
    });

    return childs;
}

module.exports = componentsFinder;
